import { Drop, Flask, PottedPlant, Lamp } from "@phosphor-icons/react";

export const REMINDER_META = {
  watering: { label: "Water", Icon: Drop, color: "#0A84FF" },
  fertilizing: { label: "Fertilize", Icon: Flask, color: "#30D158" },
  repotting: { label: "Repot", Icon: PottedPlant, color: "#AF52DE" },
  grow_light: { label: "Check grow light", Icon: Lamp, color: "#E8A100" },
};

export const STATUS_COLOR = { overdue: "#FF453A", due: "#FF9F0A", soon: "#8E8E93", ok: "#8E8E93", paused: "#0071E3" };

export const isActionable = (r) => r.status !== "ok" && r.status !== "paused";

export const whenText = (r) =>
  r.status === "paused" ? "paused for cold season" : r.days_until < -14 ? "overdue" : r.days_until < 0 ? `overdue ${-r.days_until}d` : r.days_until === 0 ? "due today" : `due in ${r.days_until}d`;

export const reminderText = (r) => `${REMINDER_META[r.event_type].label} ${whenText(r)}`;

export const urgentByPlant = (list) =>
  list.filter(isActionable).reduce((m, r) => (m[r.plant_id] && m[r.plant_id].days_until <= r.days_until ? m : { ...m, [r.plant_id]: r }), {});
